<template>
  <div class="language-switcher">
    <button
      class="lang-btn"
      :class="{ active: locale === 'en_IN' }"
      @click="setLocale('en_IN')"
      title="English"
    >
      English
    </button>
    <span class="separator">|</span>
    <button
      class="lang-btn"
      :class="{ active: locale === 'ta_IN' }"
      @click="setLocale('ta_IN')"
      title="தமிழ்"
    >
      தமிழ்
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const props = defineProps({
  storageKey: {
    type: String,
    default: 'app_locale'
  }
})

const { locale } = useI18n()

const setLocale = (lang) => {
  locale.value = lang
  localStorage.setItem(props.storageKey, lang)
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: var(--space-2, 8px);
}

.lang-btn {
  padding: 0;
  border: none;
  background: transparent;
  font-size: var(--font-size-sm, 14px);
  font-weight: var(--font-weight-medium, 500);
  color: var(--color-gray-400, #9ca3af);
  cursor: pointer;
  transition: color 0.15s ease;
}

.lang-btn:hover {
  color: var(--color-gray-600, #4b5563);
}

.lang-btn.active {
  color: var(--color-blue, #0066ff);
  font-weight: var(--font-weight-semibold, 600);
}

.separator {
  color: var(--color-gray-300, #d1d5db);
  font-size: var(--font-size-sm, 14px);
}
</style>
